import React from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Layout } from "./components/Layout";

import { Home } from "./pages/Home";
import { Pricing } from "./pages/Pricing";
import { Starters } from "./pages/Starters";
import { StarterDetail } from "./pages/StarterDetail";
import { Enterprise } from "./pages/Enterprise";
import { Docs } from "./pages/Docs";
import { FeatureTemplate } from "./pages/FeatureTemplate";
import { ICPTemplate } from "./pages/ICPTemplate";
import { RedirectToAppAuth } from "./pages/RedirectToAppAuth";

function ScrollToTopWrapper({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  React.useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname, location.search]);
  return <>{children}</>;
}

function App() {
  return (
    <ScrollToTopWrapper>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/starters" element={<Starters />} />
          <Route path="/starters/:starterId" element={<StarterDetail />} />
          <Route path="/enterprise" element={<Enterprise />} />
          <Route path="/docs" element={<Docs />} />

          {/* Dynamic routes */}
          <Route path="/features/:slug" element={<FeatureTemplate />} />
          <Route path="/for/:slug" element={<ICPTemplate />} />

          {/* App auth redirects */}
          <Route path="/signup" element={<RedirectToAppAuth kind="sign-up" />} />
          <Route path="/login" element={<RedirectToAppAuth kind="sign-in" />} />

          {/* Placeholders (keep links non-broken) */}
          <Route path="/blog" element={<Navigate to="/" replace />} />
          <Route path="/contact" element={<Navigate to="/" replace />} />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    </ScrollToTopWrapper>
  );
}

export default App
